export default __webpack_public_path__ + "static/media/MiniSlide-1.1fb779da.jpeg";